import type { DocumentSets, RecognitionPathContractDocumentType, TypedSetDocumentType } from "./document-set-settings";

interface DocumentSetGroup<T extends TypedSetDocumentType> {
  name: string;
  sets: DocumentSets<T>;
}

type DocumentSetGroupArray<K extends TypedSetDocumentType> = [
  DocumentSetGroup<K>,
  DocumentSetGroup<K>,
  ...DocumentSetGroup<K>[],
];

type DocumentSetGroupMap = Partial<{
  [K in TypedSetDocumentType]: DocumentSetGroupArray<K>;
}>;

function buildGroups<T extends RecognitionPathContractDocumentType>(): DocumentSetGroupArray<T> {
  return [
    {
      name: "CurrentRecognitionPath",
      sets: [
        "SignedByAllPartiesCurrentRecognitionPath",
        "SignedByOnePartyCurrentRecognitionPath",
        "UnsignedCurrentRecognitionPath",
      ],
    },
    {
      name: "AlternativeRecognitionPath",
      sets: [
        "SignedByAllPartiesAlternativeRecognitionPath",
        "SignedByOnePartyAlternativeRecognitionPath",
        "UnsignedAlternativeRecognitionPath",
      ],
    },
  ];
}

export const DocumentSetGroupsSettings: DocumentSetGroupMap = {
  POACHILDREN81A: buildGroups(),
  POAPARTNER81A: buildGroups(),
  POACANDIDATE: buildGroups(),
  POAMAIN81A: buildGroups(),
  POASUB81A: buildGroups(),
  AUTHACCEPTAGENCY: buildGroups(),
  POWEROFATTORNEYRELOCATION: buildGroups(),
  GENERALPOA: buildGroups(),
  POAFAMILIY81A: buildGroups(),
  POWEROFATORNEYWORKRECOGNITION: buildGroups(),
  POWEROFATTORNEYVALUATION: buildGroups(),
};
